import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  rewardTypeRes: [],
  rewardTypeMapping: {},
};

const rewardSlice = createSlice({
  name: "reward",
  initialState,
  reducers: {
    setRewardTypeRes(state, action) {
      state.rewardTypeRes = action?.payload;
    },
    setRewardTypeMapping(state, action) {
      state.rewardTypeMapping = action?.payload;
    },
  },
});

export const { setRewardTypeRes, setRewardTypeMapping } = rewardSlice.actions;
export default rewardSlice.reducer;
